import { render, staticRenderFns } from "./CardSelector.vue?vue&type=template&id=05ac55b2&scoped=true&"
import script from "./CardSelector.vue?vue&type=script&lang=ts&"
export * from "./CardSelector.vue?vue&type=script&lang=ts&"
import style0 from "./CardSelector.vue?vue&type=style&index=0&id=05ac55b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ac55b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
